import { render, staticRenderFns } from "./EditPassword.html?vue&type=template&id=37bbf6cf&scoped=true&"
import script from "./EditPassword.vue?vue&type=script&lang=ts&"
export * from "./EditPassword.vue?vue&type=script&lang=ts&"
import style0 from "./EditPassword.scss?vue&type=style&index=0&id=37bbf6cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bbf6cf",
  null
  
)

export default component.exports